/**
 * Errors stay up for thirty seconds, so they need a way out.
 *
 * At 3.2 seconds a toast dismissing itself was the whole interaction. A
 * failure now stays long enough to read and copy, which means sitting through
 * it is a real cost if you have already dealt with it — so it closes on a
 * click, and says so.
 */
export default function ToastContainer({ toasts, dismiss }) {
  return (
    <div className="toast-container">
      {toasts.map(t => {
        const lingers = t.type === 'error' || t.type === 'warning'
        return (
          <div
            key={t.id}
            className={`toast ${t.type}`}
            // Only the ones that linger are clickable. Making a 3-second
            // success dismissable invites clicking at the moment it vanishes
            // on its own, which feels like the click did something else.
            onClick={lingers && dismiss ? () => dismiss(t.id) : undefined}
            role={lingers ? 'button' : undefined}
            tabIndex={lingers ? 0 : undefined}
            onKeyDown={lingers && dismiss
              ? e => { if (e.key === 'Enter' || e.key === ' ') dismiss(t.id) }
              : undefined}
            title={lingers ? 'Click to dismiss' : undefined}
            style={lingers ? { cursor: 'pointer' } : undefined}
          >
            <div className="toast-dot" />
            <span>{t.message}</span>
            {lingers && dismiss && (
              <span
                aria-hidden="true"
                style={{
                  marginLeft: 10, opacity: .55, fontSize: 16, lineHeight: 1,
                  flexShrink: 0,
                }}
              >×</span>
            )}
          </div>
        )
      })}
    </div>
  )
}
